if (!customElements.get("heading-slider")) {
	customElements.define(
		"heading-slider",
		class HeadingSlider extends HTMLElement {
			constructor() {
				super()

				//https://whiteleydesigns.com/code/ticker-style-continuous-flickity-slider/
				//https://github.com/metafizzy/flickity/issues/77#issuecomment-500153883

				// speed of ticker
				let tickerSpeed = 1
				let flickity = null
				let isPaused = false
				const slideshowEl = this

				// functions
				const update = () => {
					if (isPaused) return
					if (flickity.slides) {
						flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth
						flickity.selectedIndex = flickity.dragEndRestingSelect()
						flickity.updateSelectedSlide()
						flickity.settle(flickity.x)
					}
					window.requestAnimationFrame(update)
				}

				const pause = () => {
					isPaused = true
				}

				const play = () => {
					if (isPaused) {
						isPaused = false
						window.requestAnimationFrame(update)
					}
				}

				// create flickity instance
				flickity = new Flickity(slideshowEl, {
					cellAlign: "left",
					setGallerySize: true,
					dragThreshold: 25,
					pageDots: false,
					prevNextButtons: false,
					autoPlay: false,
					draggable: true,
					wrapAround: true,
					selectedAttraction: 0.015,
					friction: 0.25,
				})
				// flickity.x = 0s

				// event listeners
				slideshowEl.addEventListener("mouseenter", pause, false)
				slideshowEl.addEventListener("focusin", pause, false)
				slideshowEl.addEventListener("mouseleave", play, false)
				slideshowEl.addEventListener("focusout", play, false)

				flickity.on("dragStart", () => {
					isPaused = true
					document.ontouchmove = () => false
				})

				flickity.on("dragEnd", () => (document.ontouchmove = () => true))

				// start ticker
				update() // speed of ticker
			}
		}
	)
}
